// import React, { useEffect, useState } from 'react';
// import { Box, Typography } from '@mui/material';
// import axios from 'axios';
// import TableComponent from '../../Components/TableComponent/TableComponent';
// import { SnackBarComponent } from '../../Components/snackBar/snackBar';
// import { API_BASE_URL } from '../../config';
// import { LoadingSpinner } from '../../Components/spinner/spinner';

// export const StaffAssetSec13Component = () => {
//   const [rows, setRows] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [snackbarOpen, setSnackbarOpen] = useState(false);
//   const [snackbarMessage, setSnackbarMessage] = useState('');
//   const [snackbarSeverity, setSnackbarSeverity] = useState('info');

//   const columns = [
//     { id: 'slNo', field: 'slNo', headerName: 'Sl. No', width: 70 },
//     { id: 'fe_name', field: 'fe_name', headerName: 'Financial Establishment', width: 200 },
//     { id: 'fe_ca', field: 'fe_ca', headerName: 'Competent Authority', width: 200 },
//     { id: 'property_detals', field: 'property_detals', headerName: 'Property Details', width: 250 },
//     { id: 'survey_no', field: 'survey_no', headerName: 'Survey No', width: 150 },
//     { id: 'property_type', field: 'property_type', headerName: 'Property Type', width: 150 },
//     { id: 'type_of_asset', field: 'type_of_asset', headerName: 'Type of Asset', width: 150 },
//     { id: 'hobli', field: 'hobli', headerName: 'Hobli', width: 120 },
//     { id: 'village', field: 'village', headerName: 'Village', width: 120 },
//     { id: 'taluk', field: 'taluk', headerName: 'Taluk', width: 120 },
//     { id: 'district', field: 'district', headerName: 'District', width: 120 },
//     { id: 'state', field: 'state', headerName: 'State', width: 120 },
//     { id: 'pincode', field: 'pincode', headerName: 'Pincode', width: 100 },
//     { id: 'geo_location', field: 'geo_location', headerName: 'Geo Location', width: 200 },
//     { id: 'misc_no', field: 'misc_no', headerName: 'Misc No', width: 150 },
//     { id: 'appeal', field: 'appeal', headerName: 'Appeal', width: 150 },
//     { id: 'doc', field: 'doc', headerName: 'Document', width: 300 },
//     { id: 'status', field: 'status', headerName: 'Status', width: 150 },
//     { id: 'final_ord', field: 'final_ord', headerName: 'Final Order', width: 300 },
//     { id: 'Final_remark', field: 'Final_remark', headerName: 'Final Remark', width: 300 },
//   ];

//   useEffect(() => {
//     axios.get(`${API_BASE_URL}/asset-mgmt/asset-sec13/`)
//       .then((response) => {
//         const apiData = response.data.map((item, index) => ({
//           id: item.id || index,
//           slNo: index + 1,
//           fe_name: item.fe?.name_of_fe || '-',
//           fe_ca: item.fe?.name_of_ca || '-',
//           property_detals: item.property_detals || '-',
//           survey_no: item.survey_no || '-',
//           property_type: item.property_type || '-',
//           type_of_asset: item.type_of_asset || '-',
//           hobli: item.hobli || '-',
//           village: item.village || '-',
//           taluk: item.taluk || '-',
//           district: item.district || '-',
//           state: item.state || '-',
//           pincode: item.pincode || '-',
//           geo_location: item.geo_location || '-',
//           misc_no: item.misc_no || '-',
//           appeal: item.appeal || '-',
//           doc: item.doc || '-',
//           status: item.status || '-',
//           final_ord: item.final_ord || '-',
//           Final_remark: item.Final_remark || '-',
//         }));
//         setRows(apiData);
//         setSnackbarMessage('Asset Sec 13 data loaded successfully.');
//         setSnackbarSeverity('success');
//         setSnackbarOpen(true);
//         setLoading(false);
//       })
//       .catch(() => {
//         setSnackbarMessage('Failed to load Asset Sec 13 data.');
//         setSnackbarSeverity('error');
//         setSnackbarOpen(true);
//         setLoading(false);
//       });
//   }, []);

//   const handleSnackbarClose = () => setSnackbarOpen(false);

//   if (loading) {
//     return <LoadingSpinner size={30} />;
//   }

//   return (
//     <Box sx={{
//       width: '100%',
//       mt: 8,
//       mb: 1,
//       borderRadius: 2,
//       boxShadow: '0 4px 12px rgba(0, 0, 0, 0.1)',
//       backgroundColor: '#fff',
//     }}>
//       <Box display="flex" justifyContent="center" backgroundColor="rgba(195, 234, 203, 0.1)" mb={2}>
//         <Typography variant="h4" component="h1" align="center" sx={{ fontWeight: 'bold' }}>
//           Asset Sec 13
//         </Typography>
//       </Box>

//       <TableComponent
//         columns={columns}
//         rows={rows}
//         manageColumnStatus
//         enableSort
//         sx={{
//           '& .MuiDataGrid-columnHeaders': {
//             backgroundColor: '#1976d2',
//             color: '#fff',
//             fontWeight: 'bold',
//           },
//         }}
//       />

//       <SnackBarComponent
//         open={snackbarOpen}
//         message={snackbarMessage}
//         severity={snackbarSeverity}
//         onClose={handleSnackbarClose}
//       />
//     </Box>
//   );
// };



import React, { useEffect, useState } from 'react';
import { Box, Typography } from '@mui/material';
import axios from 'axios';
import TableComponent from '../../Components/TableComponent/TableComponent';
import { SnackBarComponent } from '../../Components/snackBar/snackBar';
import { API_BASE_URL } from '../../config';
import { LoadingSpinner } from '../../Components/spinner/spinner';

export const StaffAssetSec13Component = () => {
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState('');
  const [snackbarSeverity, setSnackbarSeverity] = useState('info');

  const columns = [
    { id: 'slNo', field: 'slNo', headerName: 'Sl. No', width: 70 },
    { id: 'fe_name', field: 'fe_name', headerName: 'Financial Establishment', width: 200 },
    { id: 'fe_ca', field: 'fe_ca', headerName: 'Competent Authority', width: 200 },
    { id: 'property_detals', field: 'property_detals', headerName: 'Property Details', width: 250 },
    { id: 'survey_no', field: 'survey_no', headerName: 'Survey No', width: 150 },
    { id: 'property_type', field: 'property_type', headerName: 'Property Type', width: 150 },
    { id: 'type_of_asset', field: 'type_of_asset', headerName: 'Type of Asset', width: 150 },
    { id: 'hobli', field: 'hobli', headerName: 'Hobli', width: 120 },
    { id: 'village', field: 'village', headerName: 'Village', width: 120 },
    { id: 'taluk', field: 'taluk', headerName: 'Taluk', width: 120 },
    { id: 'district', field: 'district', headerName: 'District', width: 120 },
    { id: 'state', field: 'state', headerName: 'State', width: 120 },
    { 
      id: 'pincode', 
      field: 'pincode', 
      headerName: 'Pincode', 
      width: 100 
    },
    {
      id: 'geo_location',
      field: 'geo_location',
      headerName: 'Geo Location',
      width: 200,
      renderCell: (params) =>
        params.value && params.value !== '-' ? (
          <a
            href={params.value}
            target="_blank"
            rel="noopener noreferrer"
            style={{ color: '#1976d2', textDecoration: 'none', fontWeight: 500 }}
          >
            View
          </a>
        ) : (
          <span>-</span>
        ),
    },
    {
      id: 'doc',
      field: 'doc',
      headerName: 'Order Document',
      width: 300,
      renderCell: (params) =>
        params.value && params.value !== '-' ? (
          <a
            href={params.value}
            target="_blank"
            rel="noopener noreferrer"
            style={{ color: '#1976d2', textDecoration: 'none', fontWeight: 500 }}
          >
            View
          </a>
        ) : (
          <span>-</span>
        ),
    },
    { id: 'appeal', field: 'appeal', headerName: 'Appeal', width: 150 },
    { id: 'misc_no', field: 'misc_no', headerName: 'Case No', width: 150 },
    { id: 'status', field: 'status', headerName: 'Status', width: 150 },
    {
      id: 'final_ord',
      field: 'final_ord',
      headerName: 'Final Order',
      width: 300,
      renderCell: (params) =>
        params.value && params.value !== '-' ? (
          <a
            href={params.value}
            target="_blank"
            rel="noopener noreferrer"
            style={{ color: '#1976d2', textDecoration: 'none', fontWeight: 500 }}
          >
            View
          </a>
        ) : (
          <span>-</span>
        ),
    },
    { id: 'Final_remark', field: 'Final_remark', headerName: 'Final Remark', width: 300 },
  ];

  useEffect(() => {
    axios.get(`${API_BASE_URL}/asset-mgmt/asset-sec13/`)
      .then((response) => {
        const apiData = response.data.map((item, index) => ({
          id: item.id || index,
          slNo: index + 1,
          fe_name: item.fe?.name_of_fe || '-',
          fe_ca: item.fe?.name_of_ca || '-',
          property_detals: item.property_detals || '-',
          survey_no: item.survey_no || '-',
          property_type: item.property_type || '-',
          type_of_asset: item.type_of_asset || '-',
          hobli: item.hobli || '-',
          village: item.village || '-',
          taluk: item.taluk || '-',
          district: item.district || '-',
          state: item.state || '-',
          pincode: item.pincode || '-',
          geo_location: item.geo_location || '-',
          misc_no: item.misc_no || '-',
          appeal: item.appeal || '-',
          doc: item.doc_link || item.doc || '-',
          status: item.status || '-',
          final_ord: item.final_ord_link || item.final_ord || '-',
          Final_remark: item.Final_remark || '-',
        }));
        setRows(apiData);
        setSnackbarMessage('Asset Sec 13 data loaded successfully.');
        setSnackbarSeverity('success');
        setSnackbarOpen(true);
        setLoading(false);
      })
      .catch(() => {
        setSnackbarMessage('Failed to load Asset Sec 13 data.');
        setSnackbarSeverity('error');
        setSnackbarOpen(true);
        setLoading(false);
      });
  }, []);

  const handleSnackbarClose = () => setSnackbarOpen(false);

  if (loading) {
    return <LoadingSpinner size={30} />;
  }

  return (
    <Box sx={{
      width: '100%',
      mt: 8,
      mb: 1,
      borderRadius: 2,
      boxShadow: '0 4px 12px rgba(0, 0, 0, 0.1)',
      backgroundColor: '#fff',
    }}>
      <Box display="flex" justifyContent="center" backgroundColor="rgba(195, 234, 203, 0.1)" mb={2}>
        <Typography variant="h4" component="h1" align="center" sx={{ fontWeight: 'bold' }}>
          Asset Sec 13
        </Typography>
      </Box>

      <TableComponent
        columns={columns}
        rows={rows}
        manageColumnStatus
        enableSort
        sx={{
          '& .MuiDataGrid-columnHeaders': {
            backgroundColor: '#1976d2',
            color: '#fff',
            fontWeight: 'bold',
          },
        }}
      />

      <SnackBarComponent
        open={snackbarOpen}
        message={snackbarMessage}
        severity={snackbarSeverity}
        onClose={handleSnackbarClose}
      />
    </Box>
  );
};
